import React, { useContext } from "react";
import { NewProjectContext } from "../context/NewProjectContext";
import { useHistory } from "react-router-dom";
import "../scss/need-panel.scss";
import it from "../assets/needs/computer-icon.png";
import marketing from "../assets/needs/marketing.png";
import others from "../assets/needs/others.png";

const NeedCard = ({ name, img, handleClick }) => {
  const { need, handleNeed } = useContext(NewProjectContext);
  const selected = need === name ? "selected" : "";

  const onClick = () => {
    handleNeed(name);
    handleClick();
  };

  return (
    <div className={`need ${selected}`} onClick={onClick}>
      <div className="img-container">
        <img src={img} alt="" />
      </div>
      <span>{name}</span>
    </div>
  );
};

const NeedPanel = () => {
  const history = useHistory();

  const onClick = () => history.push("/newproject/pack");

  return (
    <div className="panel">
      <h1>Quel est votre besoin ?</h1>
      <div className="needs-container">
        <NeedCard name="Informatique & Web" img={it} handleClick={onClick} />
        <NeedCard name="Marketing" img={marketing} handleClick={onClick} />
        <NeedCard name="Autre" img={others} handleClick={onClick} />
      </div>
    </div>
  );
};

export default NeedPanel;
